import ErrorPage from "@/components/ErrorPages/DefaultErrorPage";
import { ScheduleHome } from "@/components/Schedule/ScheduleHome";
import AppointmentDetail from "@/pages/Appointments/AppointmentDetail";
import AppointmentsPage from "@/pages/Appointments/AppointmentsPage";
import PrintAppointments from "@/pages/Appointments/components/PrintAppointments";
import { ManageQueuePage } from "@/pages/Facility/queues/ManageQueue";
import QueuesIndex from "@/pages/Facility/queues/QueuesIndex";
import { SchedulableResourceType } from "@/types/scheduling/schedule";
import { Redirect, useRoutes } from "raviger";
import HealthcareServiceShow from "./HealthcareServiceShow";
import useCurrentService from "./utils/useCurrentService";

interface ServiceLayoutProps {
  facilityId: string;
  serviceId: string;
}

const getRoutes = (
  facilityId: string,
  serviceId: string,
  serviceName: string,
) => ({
  "/locations": () => (
    <HealthcareServiceShow facilityId={facilityId} serviceId={serviceId} />
  ),

  // Schedule
  "/schedule": () => (
    <ScheduleHome
      facilityId={facilityId}
      resourceType={SchedulableResourceType.HealthcareService}
      resourceId={serviceId}
    />
  ),

  // Appointments
  "/appointments": () => (
    <AppointmentsPage
      resourceType={SchedulableResourceType.HealthcareService}
      resourceId={serviceId}
      name={serviceName}
    />
  ),
  "/appointments/print": () => (
    <PrintAppointments
      facilityId={facilityId}
      resourceType={SchedulableResourceType.HealthcareService}
      resourceId={serviceId}
    />
  ),
  "/appointments/:appointmentId": ({
    appointmentId,
  }: {
    appointmentId: string;
  }) => <AppointmentDetail appointmentId={appointmentId} />,

  // Queues
  "/queues": () => (
    <QueuesIndex
      facilityId={facilityId}
      resourceType={SchedulableResourceType.HealthcareService}
      resourceId={serviceId}
    />
  ),
  "/queues/:queueId": ({ queueId }: { queueId: string }) => (
    <Redirect
      to={`/facility/${facilityId}/services/${serviceId}/queues/${queueId}/ongoing`}
    />
  ),
  "/queues/:queueId/ongoing": ({ queueId }: { queueId: string }) => (
    <ManageQueuePage
      facilityId={facilityId}
      resourceType={SchedulableResourceType.HealthcareService}
      resourceId={serviceId}
      queueId={queueId}
      tab="ongoing"
    />
  ),

  "/queues/:queueId/completed": ({ queueId }: { queueId: string }) => (
    <ManageQueuePage
      facilityId={facilityId}
      resourceType={SchedulableResourceType.HealthcareService}
      resourceId={serviceId}
      queueId={queueId}
      tab="completed"
    />
  ),

  "*": () => <ErrorPage />,
});

export function ServiceLayout({ facilityId, serviceId }: ServiceLayoutProps) {
  const { service } = useCurrentService();
  const serviceName = service?.name ?? "";
  const basePath = `/facility/${facilityId}/services/${serviceId}`;
  const routeResult = useRoutes(getRoutes(facilityId, serviceId, serviceName), {
    basePath,
    routeProps: {
      facilityId,
      serviceId,
    },
  });

  return <div>{routeResult}</div>;
}
